export const COPY_PERSONAL_INFORMATION_TITLE = "Personal information";
export const COPY_PERSONAL_INFORMATION_SUCCESS_TITLE =
  "Personal information updated!";
